import { DollarOutlined } from '@ant-design/icons'
import { Col, Input, Modal, Row, Table, Form, Button } from 'antd'
import React, { useRef, useEffect, useState } from 'react'
import axios from 'axios'
import { openNotification } from '../../../utils/Notifactions'
import { saveFile } from '../../../utils/saveFile'
import apiParticipantes from '../../../api/Participantes/api-participantes'
import apiJurados from '../../../api/Jurados/api-jurados'
import { useMaestras } from '../../../hooks/useMaestras'
import { Console } from 'console'
import { ObjNotificaciones } from '../../../config/notificaciones'

type ModalListadoProps = {
    openModal: boolean,
    setOpenModal: Function,
    datos: any,
    obtenerAllJuradosPago: any,
    setPostulaciones: any,
    setTodasLasPostulaciones: any
}
export const ModalListado = ({ openModal, setOpenModal, datos, obtenerAllJuradosPago, setPostulaciones, setTodasLasPostulaciones }: ModalListadoProps) => {

    const fileInputRef = useRef<any>();
    const [dataProyectoJurado, setDataProyectoJurado] = useState<any>([])
    const [sumaPagar, setSumaPagar] = useState<any>(0)
    const [nombreDocumento, setNombreDocumento] = useState<any>("")

    const setLimpiarCampos = () => {
        if (dataProyectoJurado.length !== 0) {
            for (let i = 0; i < dataProyectoJurado.length; i++) {
                let input: any = document.getElementById(`pagar_${i}`)
                if (input !== null) input.value = ""
            }
        }
    }

    const getProyectos = async () => {
        const token = localStorage.getItem('token');
        if (Object.keys(datos).length !== 0) {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_JURA2}projects/juryprojects/${datos.id}`,
                {
                    headers: {
                        "Authorization": token
                    }
                })
            setDataProyectoJurado(data.data);
            // setSumaPagar(0)
            // setLimpiarCampos()
        } else console.log('object empty');
    }

    const { lineaConvocatorias, obtenerLineaConvocatorias } = useMaestras();


    useEffect(() => {

        if (datos.path_documento !== null) {
            setNombreDocumento(datos.path_documento)
            setSumaPagar(Number(datos.total))
        }



        obtenerLineaConvocatorias();
        getProyectos()
    }, [])



    const onChangePagar = (datos: any, precio: any) => {


        setSumaPagar(0)
        if (dataProyectoJurado.length !== 0) {
            let suma: number = 0
            for (let i = 0; i < dataProyectoJurado.length; i++) {
                let input: any = document.getElementById(`pagar_${i}`)
                if (input !== null) {
                    if (input.value !== "") {
                        const valor: number = parseInt(input.value)
                        suma += valor
                    }
                }
            }
            setSumaPagar(suma)
        }

        let proyectosProyectos = dataProyectoJurado.map((x: any) => {
            if (datos.id_postulacion == x.id_postulacion) {
                return {
                    ...x,
                    precio: Number(precio)
                }
            } else {
                return {
                    ...x
                }
            }
        })

        setDataProyectoJurado(proyectosProyectos)


    }


    const guardarArchivo = async (e: any) => {
        let type = e.target.files[0].type;
        let name = e.target.files[0].name;
        if (type == 'application/pdf') {
            try {
                await saveFile(e);
                setNombreDocumento(name)
            } catch (error) {
                console.log(error)
            }

        } else {
            return openNotification({
                titulo: "Error",
                descripcion: "Solo se permiten archivos pdf",
                placement: "bottomRight",
            });
        }



    }

    const onClose = async () => {
        //console.log(' de llegar si llega')
        await obtenerAllJuradosPago()
        setOpenModal(!openModal);
    }


    const columns: any = [
        {
            title: "No.",
            width: 10,
            // dataIndex: "",
            key: "index",
            render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
        },
        {
            title: "Nombre proyecto",
            width: 80,
            dataIndex: "nombre_propuesta",
            key: "nombre_propuesta",
        },
        {
            title: "Código",
            width: 100,
            dataIndex: "radicado",
            key: "radicado",
        },
        {
            title: "Línea",
            width: 80,
            render: (datos: any) => {
                // let lineaConvocatoria : any = lineaConvocatorias.find((x: any) => x.id == datos.linea_convocatoria);
                return <span>{datos.linea_convocatoria}</span>
            }
        },
        {
            title: "Cateogoría",
            width: 100,
            dataIndex: "categoria_linea_convocatoria",
            key: "categocategoria_linea_convocatoriaria",
        },
        {
            title: "Valor a pagar",
            width: 140,
            key: 'valor_pagar',
            render: (datos: any, record: any, idx: number) => (
                <Input
                    type="number"
                    id={`pagar_${idx}`}
                    value={datos.precio}
                    style={{ textAlign: "right" }}
                    onChange={(e) => {
                        e.target.value = e.target.value.replace(/\D/, "")
                        onChangePagar(datos, e.target.value)
                    }}
                    prefix={<DollarOutlined />}
                />

            )
        }
    ]

    const guardarTodo = async () => {

        let existeUnoSinPrecio = dataProyectoJurado.find((x: any) => x.precio == null);
        if (existeUnoSinPrecio) {
            return openNotification({
                titulo: "Error",
                descripcion: "Faltan proyectos por poner el precio",
                placement: "bottomRight",
            });
        }

        if (nombreDocumento == '') {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta adjuntar el certificado",
                placement: "bottomRight",
            });
        }


        dataProyectoJurado.forEach(async (x: any) => {
            try {
                await apiParticipantes.actualizarPagoProyecto(x.id_postulacion, x.precio)
            } catch (error) {
                console.log(error);
            }
        });

        const projects = dataProyectoJurado.map((x: any) => {
            return {
                id_postulacion: x.id_postulacion
            }
        })

        let payload = {
            path_documento: nombreDocumento,
            projects: projects
        }

        await apiJurados.adjutarDocumento(datos.id, payload)
        const { data } = await apiJurados.getAllPostulacionesPagos();
        const datosFiltrados = data.map((x: any, idx: any) => {
            return {
                ...x,
                index: idx + 1
            }
        })

        ObjNotificaciones.MSG_SUCCESS('success', '¡Registro éxitoso, se han actualizado los pagos!');
        //console.log(datosFiltrados)
        setPostulaciones(datosFiltrados);
        setTodasLasPostulaciones(datosFiltrados);
        return setOpenModal(!openModal);
    }

    const currency = function (number: number) {
        return new Intl.NumberFormat('en-ES', { style: 'currency', currency: 'COP', minimumFractionDigits: 2 }).format(number);
    };



    return (
        <Modal
            className='ant-modal-close-x2'
            title={
                <div style={{ display: 'flex' }}>
                    <div className='pe-3 d-flex flex-column flex-md-row font-size-14px font-color-000000CC font-family-Montserrat-SemiBold'>
                        Datos de jurado: <span className='ms-1 font-family-Montserrat-Regular font-color-000000CC'>  {datos.nombre_completo}</span>
                    </div>
                    <div className='d-flex flex-column flex-md-row font-size-14px font-color-000000CC font-family-Montserrat-SemiBold'>
                        Código: <span className='font-family-Montserrat-Regular font-color-000000CC'>{datos.codigo}</span>
                    </div>
                </div>
            }
            width={1700}
            visible={openModal}
            onCancel={onClose}
            maskStyle={{
                backgroundColor: "rgba(6, 100, 144 ,0.8)",
            }}
            footer={
                <>
                    <div className="container-fluid">
                        <Button className="button-gray-ghost" onClick={onClose}>
                            Cerrar
                        </Button>
                        <Button className="button-azul-radius" onClick={guardarTodo}>
                            Guardar cambios
                        </Button>
                    </div>
                </>
            }
        >
            <Table
                style={{ borderTop: "1px solid #C4C4C4" }}
                // locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                // pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadPaginas }}
                dataSource={dataProyectoJurado}
                columns={columns}
                size="small"
                bordered={false}
                pagination={false}
            />

            <Row justify='end'>
                <Col>
                    <div className='font-size-12px font-color-000000CC font-family-Montserrat-SemiBold' style={{ marginTop: '13px' }}>
                        Total a pagar: $ {currency(sumaPagar)}
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Comprobante de pago.
                    </span>

                    <Input.Group compact>
                        <Input style={{ width: "calc(100% - 120px)", color: 'black' }} value={nombreDocumento} disabled={true} />
                        <Button className="no-margin buttonblanco-radius-input" style={{ height: '38px', width: "120px" }} onClick={() => fileInputRef.current.click()}>
                            ADJUNTAR
                        </Button>
                        <input ref={fileInputRef} type="file" hidden onChange={(e) => guardarArchivo(e)} />
                    </Input.Group>
                </Col>
            </Row>
        </Modal>
    )
}
